import { isArray, isFunction } from '@cloud-sn/v-utils';
import Selector from '../selector';
import SearchInput from '../searchInput';
export default {
  computed: {
    singleSelectedStyle: function singleSelectedStyle() {
      var showSearch = this.showSearch,
          searchInputValue = this.searchInputValue,
          innerVisible = this.innerVisible;
      var showSelectedValue = true;
      var opacity = 1;

      if (showSearch && innerVisible) {
        if (!searchInputValue) {
          opacity = 0.4;
        } else {
          showSelectedValue = false;
        }
      }

      return {
        display: showSelectedValue ? 'block' : 'none',
        opacity: opacity
      };
    }
  },
  methods: {
    singleSearchInputFocus: function singleSearchInputFocus() {
      var singleSearchInputRef = this.$refs.singleSearchInputRef;

      if (singleSearchInputRef) {
        singleSearchInputRef.focus();
      }
    },
    renderSingleTrigger: function renderSingleTrigger(renderSelectionInputFn) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          showArrow = this.showArrow,
          showSearch = this.showSearch,
          getSelectionValue = this.getSelectionValue,
          placeholderNode = this.placeholderNode,
          innerVisible = this.innerVisible,
          singleSelectedStyle = this.singleSelectedStyle;
      var selectionValue = getSelectionValue();
      var triggerNode = null;

      if (isArray(selectionValue) && selectionValue.length > 0) {
        var _selectionValue$ = selectionValue[0],
            title = _selectionValue$.title,
            selectionContent = _selectionValue$.selectionContent;
        triggerNode = h("span", {
          "attrs": {
            "title": title || selectionContent
          },
          "class": "".concat(prefixCls, "-selection-selected-value"),
          "style": singleSelectedStyle
        }, [selectionContent]);
        triggerNode = isFunction(renderSelectionInputFn) ? renderSelectionInputFn(triggerNode) : triggerNode;
      } else {
        triggerNode = placeholderNode;
      }

      return h(Selector, {
        "slot": "trigger",
        "attrs": {
          "show-arrow": showArrow,
          "selections": selectionValue
        }
      }, [h("div", {
        "class": "".concat(prefixCls, "-selection__rendered")
      }, [triggerNode, showSearch ? h("div", {
        "directives": [{
          name: "show",
          value: innerVisible
        }],
        "class": "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline")
      }, [h(SearchInput, {
        "ref": "singleSearchInputRef"
      })]) : null])]);
    }
  }
};